import { render, staticRenderFns } from "./MainBadge.vue?vue&type=template&id=3f11b629"
import script from "./MainBadge.vue?vue&type=script&lang=js"
export * from "./MainBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports